var _path, _path2, _path3, _path4, _rect, _path5, _rect2, _path6, _rect3, _path7, _path8, _path9, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFromOppDisabledIllustration = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 230,
    height: 127,
    viewBox: "0 0 230 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H222C226.418 0 230 3.58172 230 8V127H0V8Z",
    fill: "#F7F7F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34H98C102.142 34 105.5 37.3579 105.5 41.5V85.5C105.5 89.6421 102.142 93 98 93H22C17.8579 93 14.5 89.6421 14.5 85.5V41.5C14.5 37.3579 17.8579 34 22 34Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34H98C102.142 34 105.5 37.3579 105.5 41.5V85.5C105.5 89.6421 102.142 93 98 93H22C17.8579 93 14.5 89.6421 14.5 85.5V41.5C14.5 37.3579 17.8579 34 22 34Z",
    stroke: "#B3B3B3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 47.5C36.5 45.0147 34.4853 43 32 43C29.5147 43 27.5 45.0147 27.5 47.5C27.5 49.9853 29.5147 52 32 52C34.4853 52 36.5 49.9853 36.5 47.5ZM37.5 47.5C37.5 50.5376 35.0376 53 32 53C28.9624 53 26.5 50.5376 26.5 47.5C26.5 44.4624 28.9624 42 32 42C35.0376 42 37.5 44.4624 37.5 47.5Z",
    fill: "#B3B3B3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 50)",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 63.5C36.5 61.0147 34.4853 59 32 59C29.5147 59 27.5 61.0147 27.5 63.5C27.5 65.9853 29.5147 68 32 68C34.4853 68 36.5 65.9853 36.5 63.5ZM33.1465 62.1465C33.3417 61.9512 33.6583 61.9512 33.8535 62.1465C34.0488 62.3417 34.0488 62.6583 33.8535 62.8535L31.8535 64.8535C31.6583 65.0488 31.3417 65.0488 31.1465 64.8535L30.1465 63.8535C29.9512 63.6583 29.9512 63.3417 30.1465 63.1465C30.3417 62.9512 30.6583 62.9512 30.8535 63.1465L31.5 63.793L33.1465 62.1465ZM37.5 63.5C37.5 66.5376 35.0376 69 32 69C28.9624 69 26.5 66.5376 26.5 63.5C26.5 60.4624 28.9624 58 32 58C35.0376 58 37.5 60.4624 37.5 63.5Z",
    fill: "#B3B3B3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 66)",
    fill: "#F7F7F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 79.5C36.5 77.0147 34.4853 75 32 75C29.5147 75 27.5 77.0147 27.5 79.5C27.5 81.9853 29.5147 84 32 84C34.4853 84 36.5 81.9853 36.5 79.5ZM37.5 79.5C37.5 82.5376 35.0376 85 32 85C28.9624 85 26.5 82.5376 26.5 79.5C26.5 76.4624 28.9624 74 32 74C35.0376 74 37.5 76.4624 37.5 79.5Z",
    fill: "#B3B3B3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 5,
    rx: 2.5,
    transform: "matrix(1 0 0 -1 42 82)",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.061 64.5607C138.646 63.9749 138.646 63.0251 138.061 62.4393L128.515 52.8934C127.929 52.3076 126.979 52.3076 126.393 52.8934C125.808 53.4792 125.808 54.4289 126.393 55.0147L134.879 63.5L126.393 71.9853C125.808 72.5711 125.808 73.5208 126.393 74.1066C126.979 74.6924 127.929 74.6924 128.515 74.1066L138.061 64.5607ZM114 63.5V65H137V63.5V62H114V63.5Z",
    fill: "#B3B3B3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153 22H208C212.142 22 215.5 25.3579 215.5 29.5V97.5C215.5 101.642 212.142 105 208 105H153C148.858 105 145.5 101.642 145.5 97.5V29.5C145.5 25.3579 148.858 22 153 22Z",
    fill: "#B3B3B3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M153 22H208C212.142 22 215.5 25.3579 215.5 29.5V97.5C215.5 101.642 212.142 105 208 105H153C148.858 105 145.5 101.642 145.5 97.5V29.5C145.5 25.3579 148.858 22 153 22Z",
    stroke: "#B3B3B3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 6,
    rx: 3,
    transform: "matrix(1 0 0 -1 157 39.5)",
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 49.5)",
    fill: "#CCCCCC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 57.5)",
    fill: "#CCCCCC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 67.5)",
    fill: "#CCCCCC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 75.5)",
    fill: "#CCCCCC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 85.5)",
    fill: "#CCCCCC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 157 93.5)",
    fill: "#CCCCCC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFromOppDisabledIllustration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fromOppDisabledIllustration.d7408dada6869d7b11ac2d8cfe267db6.svg";